import { Component, inject, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AsPipeModule } from '@rx-applications/shared/utils';
import { MandatoryDirectiveModule, RxInputModule, RxSelectModule } from '@roomex/rx-components';
import { ReactiveFormsModule } from '@angular/forms';
import { FormElement } from '@rx-applications/shared/utils-forms';
import { SelectOption } from '@rx-applications/shared/ui';
import { TranslocoDirective, TranslocoPipe, TranslocoService } from '@ngneat/transloco';
import { GuestbookForm } from '@rx-applications/clientsite-guestbook/utils';
import { TRANSLATION_SCOPE, translationProvider } from './i18n/translation.provider';
import { map, Observable } from 'rxjs';

@Component({
  selector: 'rx-applications-guest-form',
  standalone: true,
  imports: [
    CommonModule,
    MandatoryDirectiveModule,
    ReactiveFormsModule,
    RxInputModule,
    RxSelectModule,
    AsPipeModule,
    TranslocoPipe,
    TranslocoDirective,
  ],
  templateUrl: './guest-form.component.html',
  styleUrls: ['./guest-form.component.scss'],
  providers: [translationProvider],
})
export class GuestFormComponent extends FormElement implements OnInit {
  protected readonly TRANSLATION_SCOPE = TRANSLATION_SCOPE;

  @Input() compact = false;
  @Input() borderBottom = false;

  #transloco: TranslocoService = inject(TranslocoService);

  titleOptions$: Observable<SelectOption[]> = this.#transloco.selectTranslate('salutation', {}, this.TRANSLATION_SCOPE).pipe(
    map((salutations: string[]) =>
      salutations.map((title) => ({
        label: title,
        value: title,
      }))
    )
  );

  constructor() {
    super();
  }

  override ngOnInit(): void {
    super.ngOnInit();
    if (this.formSectionName) {
      this.add(GuestbookForm.Guest);
    }
  }
}
